import { Box, Tooltip } from "@chakra-ui/react";
import { BsCalendar } from "react-icons/bs";
import { Link } from "react-router-dom";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Icon } from "components/Icon";

interface IProps {
  id: string;
}

const DefaultLogo = ({ id }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { logoMainDescription, logoMainHref } = useContextConsumer();
  const logoDescription = logoMainDescription || "E-Rezerwacja";

  if (!logoMainHref) {
    return (
      <Link to={`/e-rezerwacja/${friendlyUrl}`} id={id}>
        <Logo logoDescription={logoDescription} />
      </Link>
    );
  }

  return (
    <a href={logoMainHref} id={id}>
      <Logo logoDescription={logoDescription} />
    </a>
  );
};

const Logo = ({ logoDescription }: { logoDescription: string }) => {
  return (
    <Tooltip label={logoDescription} aria-label={logoDescription}>
      <Box>
        <Icon icon={BsCalendar} h={10} w={10} />
      </Box>
    </Tooltip>
  );
};

export { DefaultLogo };
